// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { CheckOrdersOrderCodeDetailTable, CheckOrdersOrderDetailTable } from './components/check-orders-order-detail-table';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getCheckOrdersOrderCodeDetail, getCheckOrdersOrderDetail } from './repositories';
import { getDateDropdown, getFamiliesFactory } from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class CheckOrdersOrderDetail extends Component {

    state = {
        families: [],
        dateTypes: [],
        selectedFamily: '',
        selectedDateType: '',
        results: null,
        codeDetailResults: null
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryFamily = query.get( 'family' );
        const queryOrderingCode = query.get( 'orderingcode' );
        const queryOrderBuildWeek = query.get( 'orderbuildweek' );
        const queryDateType = decodeURIComponent( query.get( 'dateType' ) );

        if ( queryOrderingCode && queryOrderBuildWeek ) {

            this.getOrderCodeDetailResults( queryFamily, queryOrderingCode,
                queryOrderBuildWeek, queryDateType );

        } else {

            getFamiliesFactory( 'Y', 'Y' ).then( response => {

                this.props.increaseCounter();
                this.setState( {
                    families: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

            getDateDropdown( ).then( response => {

                this.props.increaseCounter();
                this.setState( {
                    dateTypes: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryFamily = query.get( 'family' );
            const queryOrderingCode = query.get( 'orderingcode' );
            const queryOrderBuildWeek = query.get( 'orderbuildweek' );
            const queryDateType = decodeURIComponent( query.get( 'dateType' ) );
            if ( queryOrderingCode && queryOrderBuildWeek ) {

                this.getOrderCodeDetailResults( queryFamily, queryOrderingCode,
                    queryOrderBuildWeek, queryDateType );

            }
            window.scrollTo( 0, 0 );

        }

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamily: val,
            results: null
        } );

    }

    handleDateTypeChange ( val ) {

        this.setState( {
            selectedDateType: val,
            results: null
        }, () => {

            if ( this.state.selectedFamily !== '-1' && this.state.selectedDateType !== '-1' ) {

                this.refresh();

            }

        } );

    }

    getOrderCodeDetailResults ( family, orderingCode, orderBuildWeek, dateType ) {

        this.props.increaseCounter();
        getCheckOrdersOrderCodeDetail( family, dateType, orderingCode, orderBuildWeek )
            .then( response => {

                this.setState( {
                    codeDetailResults: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    refresh () {

        if ( this.state.selectedFamily !== '-1' && this.state.selectedDateType !== '-1' ) {

            this.props.increaseCounter();
            getCheckOrdersOrderDetail( this.state.selectedFamily, this.state.selectedDateType )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedFamily, selectedDateType, families, dateTypes, results, codeDetailResults
        } = this.state;

        const finalCheckOrderResults = results !== null && results.checkOrderDetails !== null ?
            results.checkOrderDetails.map( i => (
                {
                    ...i,
                    ...{ unitName: this.props.unit.name },
                    ...{ reportType: results.reportType },
                    ...{ selectedDateType }
                } ) ) : [];
        const finalCheckOrderCodeResults = codeDetailResults !== null &&
            codeDetailResults.resultsList !== null ?
            codeDetailResults.resultsList.map( i => (
                {
                    ...i,
                    ...{ unitName: this.props.unit.name },
                    ...{ reportType: codeDetailResults.reportType }
                } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Check Orders - Order Detail</h2>
                </header>

                <main>
                    {( codeDetailResults === null && (
                        <section className="section-container">
                            <div className="atp-top-options atp-check-orders-order-detail-top-options">
                                <div className="select-options">
                                    <OptionsDropDown
                                        className="atp-check-orders-detail-select"
                                        label="Family"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleFamilyChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={families}
                                        placeholder="Select Family"
                                        selectedValue={selectedFamily}
                                    />
                                    <OptionsDropDown
                                        className="atp-check-orders-detail-select"
                                        label="Date"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleDateTypeChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={dateTypes}
                                        placeholder="Select Date"
                                        selectedValue={selectedDateType}
                                    />
                                    {selectedFamily && selectedDateType && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                                </div>
                            </div>
                            { results !== null && results.checkOrderDetails.length === 0 && (
                                <div className="errorMessage">There are no orders with code build weeks later than the order build week for family {selectedFamily} and a {selectedDateType} date. </div>
                            )}
                            { results !== null && results.checkOrderDetails.length > 0 && (
                                <CheckOrdersOrderDetailTable
                                    results={finalCheckOrderResults}
                                />
                            )}
                        </section>
                    )
                    )}
                    { codeDetailResults !== null && (
                        <section className="section-container">
                            <CheckOrdersOrderCodeDetailTable results={finalCheckOrderCodeResults} />
                        </section>
                    )}
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

CheckOrdersOrderDetail.displayName = 'CheckOrdersOrderDetail';
CheckOrdersOrderDetail.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( CheckOrdersOrderDetail ) );
